// Registered style module for the ai-loading component.
// Provides shimmer skeleton animation for loading placeholder rows.

const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
    <style>
    .ai-loading {
      width: 100%;
      border-radius: 18px;
      overflow: hidden;
      background: #ffffff;
      box-shadow: 0px 1px 34.5px rgba(72, 141, 255, 0.12);
      padding: 16px;
      box-sizing: border-box;
    }
    .row {
      height: 12px;
      border-radius: 8px;
      background: linear-gradient(
        90deg,
        rgba(236, 236, 236, 0.7) 0%,
        rgba(236, 236, 236, 1) 50%,
        rgba(236, 236, 236, 0.7) 100%
      );
      background-size: 200% 100%;
      animation: shimmer 1.25s infinite;
    }
    .row + .row {
      margin-top: 10px;
    }
    .row.w60 {
      width: 60%;
    }
    .row.w85 {
      width: 85%;
    }
    .row.w40 {
      width: 40%;
    }
    @keyframes shimmer {
      0% {
        background-position: 200% 0;
      }
      100% {
        background-position: -200% 0;
      }
    }
    </style>
</template>`;
styleElement.register("loading-display-style");
